module.exports = __webpack_public_path__ + "static/reindeer-body-3f63731d89d1c9b47c74376908768d10.png";